import { ComponentProps, useState } from 'react'

import { Button } from '@/components/Button'
import { CloseSmallIcon } from '@/components/icons/CloseSmallIcon'
import { StarRating } from '@/components/StarRating'
import { getSlugTranslation } from '@/locale/utils'

interface RatingProps {
  onClose: () => void
  onSubmit: ComponentProps<typeof StarRating>['onSelectRating']
}

export const Rating = ({ onClose, onSubmit }: RatingProps) => {
  const [selectedRating, setSelectedRating] = useState<number | null>(null)

  return (
    <div className="pointer-events-none absolute inset-0 z-20" data-testid="report-rating-overlay">
      <section
        aria-label={getSlugTranslation('general.consultation.ratingModal.title')}
        aria-modal="true"
        className="animate-slide-up pointer-events-auto absolute bottom-0 left-1/2 flex w-full max-w-160 -translate-x-1/2 flex-col gap-6 rounded-t-3xl bg-white px-4 pt-4 pb-8 shadow-lg"
        data-testid="report-rating-sheet"
        role="dialog"
      >
        <div className="flex w-full flex-col items-center gap-4">
          <div className="flex w-full items-center justify-between py-1">
            <span className="h-6 w-6" />
            <p className="text-center font-bold">{getSlugTranslation('general.consultation.ratingModal.title')}</p>
            <button
              aria-label={getSlugTranslation('button.close')}
              className="grid h-6 w-6 place-items-center text-[#1A1A1A]"
              onClick={onClose}
              type="button"
            >
              <CloseSmallIcon />
            </button>
          </div>

          <StarRating
            containerClassName="justify-center gap-4 px-0"
            selectedRating={selectedRating}
            onSelectRating={setSelectedRating}
            starSize={{ width: 32, height: 30 }}
          />
        </div>

        {selectedRating !== null && (
          <Button customClassName="px-6 text-sm leading-6" data-testid="rating-submit" hasShadow={false} onClick={() => onSubmit(selectedRating)}>
            {getSlugTranslation('button.submit')}
          </Button>
        )}
      </section>
    </div>
  )
}
